module.exports = __webpack_public_path__ + "img/i-bdsm-mono.3242abe6.svg";